import Instruction from "./Instruction";

/**
 * Show a list of alert in the same style as flash message
 */
class Flashes extends Instruction
{
	constructor(alerts)
	{
		super();
		this.alerts = alerts;
	}
	resolve(variables)
	{
		super.resolve(variables);
		this.alerts = Instruction._resolveValue(this.alerts, variables);
	}
}

export default Flashes
